import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3cd9c4ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","display":"flex","height":"100%","flex-direction":"column"} }
const _hoisted_2 = { id: "Navbar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fluence", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Form", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Element", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "bg"
}
const _hoisted_10 = {
  key: 1,
  class: "bg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FluenceView = _resolveComponent("FluenceView")!
  const _component_NavigateView = _resolveComponent("NavigateView")!
  const _component_FormView = _resolveComponent("FormView")!
  const _component_ElementView = _resolveComponent("ElementView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["wbtn", {selected: _ctx.DisplayFluenceView, disabled: _ctx.HasError }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.SetFluenceView && _ctx.SetFluenceView(...args)))
      }, _hoisted_4, 2),
      (_ctx.IsForm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["wbtn", {selected: _ctx.DisplayFormView, disabled: _ctx.HasError }]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SetFormView && _ctx.SetFormView(...args)))
          }, _hoisted_6, 2))
        : _createCommentVNode("", true),
      (_ctx.IsForm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["wbtn", {selected: _ctx.DisplayElementView, disabled: _ctx.HasError }]),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SetElementView && _ctx.SetElementView(...args)))
          }, _hoisted_8, 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.HasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.DisplayFluenceView)
            ? (_openBlock(), _createBlock(_component_FluenceView, { key: 0 }))
            : (_ctx.DisplayNavigateView)
              ? (_openBlock(), _createBlock(_component_NavigateView, { key: 1 }))
              : (_ctx.DisplayFormView)
                ? (_openBlock(), _createBlock(_component_FormView, { key: 2 }))
                : (_ctx.DisplayElementView)
                  ? (_openBlock(), _createBlock(_component_ElementView, { key: 3 }))
                  : _createCommentVNode("", true)
        ]))
  ]))
}